var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "white",
    stroke: "#685879"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5858 13.2523C14.9609 12.8772 15.4696 12.6665 16 12.6665H21.3333C21.5101 12.6665 21.6797 12.7367 21.8047 12.8618L25.8047 16.8618C25.9298 16.9868 26 17.1564 26 17.3332V25.3332C26 25.8636 25.7893 26.3723 25.4142 26.7474C25.0391 27.1225 24.5304 27.3332 24 27.3332H16C15.4696 27.3332 14.9609 27.1225 14.5858 26.7474C14.2107 26.3723 14 25.8636 14 25.3332V14.6665C14 14.1361 14.2107 13.6274 14.5858 13.2523ZM16 13.9998C15.8232 13.9998 15.6536 14.0701 15.5286 14.1951C15.4036 14.3201 15.3333 14.4897 15.3333 14.6665V25.3332C15.3333 25.51 15.4036 25.6795 15.5286 25.8046C15.6536 25.9296 15.8232 25.9998 16 25.9998H24C24.1768 25.9998 24.3464 25.9296 24.4714 25.8046C24.5964 25.6795 24.6667 25.51 24.6667 25.3332V17.9998H21.3333C20.9651 17.9998 20.6667 17.7014 20.6667 17.3332V13.9998H16ZM22 14.9426L23.7239 16.6665H22V14.9426ZM17.3333 19.9998C16.9651 19.9998 16.6667 20.2983 16.6667 20.6665C16.6667 21.0347 16.9651 21.3332 17.3333 21.3332H22.6667C23.0349 21.3332 23.3333 21.0347 23.3333 20.6665C23.3333 20.2983 23.0349 19.9998 22.6667 19.9998H17.3333ZM16.6667 23.3332C16.6667 22.965 16.9651 22.6665 17.3333 22.6665H22.6667C23.0349 22.6665 23.3333 22.965 23.3333 23.3332C23.3333 23.7014 23.0349 23.9998 22.6667 23.9998H17.3333C16.9651 23.9998 16.6667 23.7014 16.6667 23.3332ZM17.3333 17.3332C16.9651 17.3332 16.6667 17.6316 16.6667 17.9998C16.6667 18.368 16.9651 18.6665 17.3333 18.6665H18.6667C19.0349 18.6665 19.3333 18.368 19.3333 17.9998C19.3333 17.6316 19.0349 17.3332 18.6667 17.3332H17.3333Z",
    fill: "#190134"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/FileIcon.c2f5a7a395108413d5c730b2e5d31442.svg";
export { ForwardRef as ReactComponent };